import { createContext, useContext, PropsWithChildren, useState } from "react";

// @ts-ignore
export const BillDetailsContext = createContext();

type Props = {};

export function BillDetailsProvider({ children }: PropsWithChildren<Props>) {

    const [billingAccountDetailList, setBillingAccountDetailList] = useState([]);
    const [selectedBillingAccountNumber, setSelectedBillingAccountNumber] = useState();
    const [billingAccountId, setBillingAccountId] = useState();
    const [billingAccountEmail, setBillingAccountEmail] = useState();
    const [billingAccountZipCode, setBillingAccountZipCode] = useState();

    return (
        <BillDetailsContext.Provider value={
            {
                billingAccountDetailList,
                setBillingAccountDetailList,
                selectedBillingAccountNumber,
                setSelectedBillingAccountNumber,
                billingAccountId,
                setBillingAccountId,
                billingAccountEmail,
                setBillingAccountEmail,
                billingAccountZipCode,
                setBillingAccountZipCode
            }}>
            {children}
        </BillDetailsContext.Provider>
    );
}

export const useBillDetailsContext = () => useContext(BillDetailsContext);
